// @flow
import { StyledLabel } from '@src/common-utils/styledComponents';
import React from 'react';

export const CommittedCapacityDescriberContainer = () => (
  <StyledLabel size="large">
    Add metrics or components to configure committed capacity quantity
  </StyledLabel>
);
